import { Link } from "react-router-dom";
import NuggetSignup from "@/components/NuggetSignup";
import { BookOpen, Sunrise, Feather } from "lucide-react";

export default function DailyNuggets() {
  return (
    <div className="min-h-screen bg-[#07090E]">
      <div className="max-w-2xl mx-auto px-6 py-16 sm:py-24">
        <div className="text-center animate-in fade-in slide-in-from-bottom-4 duration-700">
          <Link to="/" className="inline-flex items-center gap-2 text-[#00E5FF] mb-8" data-testid="daily-home-link">
            <BookOpen className="w-5 h-5" strokeWidth={1.5} />
            <span className="text-sm font-medium uppercase tracking-[0.2em]">OpenWord AI</span>
          </Link>
          <div className="text-xs font-medium uppercase tracking-[0.2em] text-[#00E5FF] mb-3">Daily Nuggets</div>
          <h1 className="text-4xl sm:text-5xl text-white leading-tight">
            One verse. One quiet moment. Every day.
          </h1>
          <p className="text-base text-slate-400 mt-5 leading-relaxed max-w-lg mx-auto">
            A short passage and a reflection, delivered to your inbox each morning — Scripture the way it
            was written, with nothing to prove and no noise. Free, and you can leave anytime.
          </p>

          <div className="mt-10 max-w-md mx-auto">
            <NuggetSignup testid="daily-nugget-signup" />
            <p className="text-xs text-slate-500 mt-3">No account needed. One email a day. Unsubscribe with one tap.</p>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 mt-16">
          {[
            [Sunrise, "A gentle start", "One verse to carry into your day — no long reading, no pressure."],
            [Feather, "Faithful to the Word", "Christ-centered reflections grounded in the passage itself."],
            [BookOpen, "Go deeper anytime", "Each nugget links to study the passage fully in OpenWord AI — free."],
          ].map(([Icon, title, body], i) => (
            <div key={i} className="text-center sm:text-left">
              <span className="inline-flex w-10 h-10 rounded-full bg-[#10222A] text-[#00E5FF] items-center justify-center mb-3">
                <Icon className="w-5 h-5" strokeWidth={1.5} />
              </span>
              <h3 className="text-base font-medium text-slate-200">{title}</h3>
              <p className="text-sm text-slate-400 mt-1.5 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
